// src/components/ProductRangeSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const RANGES = [
  {
    title: 'OLEORESINS',
    tag: 'Concentrated Flavour. Consistent Performance.',
    image: '/assets/images/brand/oleoresin_bottle.jpg',
    points: [
      'High-potency extracts capturing the essential flavour, colour and characteristic actives of spices.',
      'Deliver greater consistency, uniformity and dosage control than conventional ground spices.',
      'Ideal for sauces, seasonings, marinades, meat, snacks, beverages and functional food applications.',
    ],
  },
  {
    title: 'ESSENTIAL OILS',
    tag: 'Pure Aroma. Protected Potency.',
    image: '/assets/images/brand/essential_oils.jpg',
    points: [
      'Highly concentrated botanical oils capturing the distinctive aromatic character of natural spices and herbs.',
      'Designed to deliver clean, consistent flavour and aroma with precise dosing and excellent dispersion.',
      'Suitable for food, beverage, flavour, fragrance and ingredient systems requiring reliable aromatic performance.',
    ],
  },
  {
    title: 'SPICE EXTRACTS',
    tag: 'Flavour, Protected.',
    image: '/assets/images/brand/spice_extracts.jpg',
    points: [
      'Natural spice extracts transformed into free-flowing powders for improved handling and stability.',
      'Gum Acacia acts as a protective wall material, encapsulating flavour compounds during spray drying.',
      'Ideal for dry blends, seasonings, instant foods, beverages, bakery and snacks.',
    ],
  },
];

const ADVANTAGE = [
  { icon: 'fa-bullseye', title: 'CONCENTRATED', sub: 'Maximum ingredient impact' },
  { icon: 'fa-shield-halved', title: 'CONSISTENT', sub: 'Reliable batch-to-batch performance' },
  { icon: 'fa-shapes', title: 'VERSATILE', sub: 'Designed for diverse applications' },
  { icon: 'fa-earth-americas', title: 'SCALABLE', sub: 'Supply solutions aligned with customer requirements' },
];

const ProductRangeSection = () => {
  return (
    <section className="page-content light">
      <div className="container">
        <div className="section-header text-center">
          <h3>Our Product Range</h3>
        </div>
        <p style={{ textAlign: 'center', maxWidth: 700, margin: '0 auto 30px' }}>
          Nature's power, perfected by science — oleoresins, essential oils and spice extracts engineered
          for consistency, potency and application flexibility.
        </p>

        <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
          {RANGES.map((r, i) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={i} style={{ marginBottom: 30 }}>
              <div style={{ background: 'var(--brand-panel)', border: '1px solid rgba(201,162,39,0.25)', borderRadius: 10, overflow: 'hidden', height: '100%', display: 'flex', flexDirection: 'column' }}>
                <img alt={r.title} src={r.image} style={{ width: '100%', height: 220, objectFit: 'cover' }} />
                <div style={{ padding: 20, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <h5 style={{ color: 'var(--brand-gold-light)', fontFamily: 'var(--brand-heading-font)', marginBottom: 4 }}>{r.title}</h5>
                  <p style={{ color: 'var(--brand-gold)', fontSize: 13, marginBottom: 12 }}>{r.tag}</p>
                  <ul style={{ listStyle: 'none', paddingLeft: 0, margin: 0 }}>
                    {r.points.map((pt, j) => (
                      <li key={j} style={{ color: 'var(--brand-cream-dim)', fontSize: 13.5, marginBottom: 8, paddingLeft: 14, textIndent: -14 }}>
                        <span style={{ color: 'var(--brand-gold)' }}>–</span> {pt}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="row" style={{ display: 'flex', flexWrap: 'wrap', marginTop: 20, textAlign: 'center' }}>
          {ADVANTAGE.map((a, i) => (
            <div className="col-6 col-md-3" key={i} style={{ marginBottom: 20 }}>
              <i className={`fas ${a.icon}`} style={{ fontSize: 24, color: 'var(--brand-gold)', display: 'block', marginBottom: 8 }}></i>
              <div style={{ color: 'var(--brand-cream)', fontWeight: 700, fontSize: 14 }}>{a.title}</div>
              <div style={{ color: 'var(--brand-cream-dim)', fontSize: 12.5 }}>{a.sub}</div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <Link className="default-button01" to="/expertise/steam-distillation">EXPLORE OUR RANGE</Link>
        </div>
      </div>
    </section>
  );
};

export default ProductRangeSection;
